import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If we already know user is logged in
  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/']);
  }

  // If bootstrap already ran and user is not authenticated
  if (authService.bootstrapped()) {
    return true;
  }

  // Otherwise run auth bootstrap first
  return authService.bootstrapAuth().pipe(
    map((isAuthed) => {
      return isAuthed ? router.createUrlTree(['/']) : true;
    }),
  );
};